import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d901828"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "value" }
const _hoisted_2 = { class: "unit" }


import Text from '@/components/text'


export default /*#__PURE__*/_defineComponent({
  __name: 'normal',
  props: ['value', 'unit'],
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createVNode(_unref(Text), {
      content: props.value
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.value || '-'), 1)
      ]),
      _: 1
    }, 8, ["content"]),
    _createElementVNode("span", _hoisted_2, _toDisplayString(props.unit), 1)
  ]))
}
}

})